/**
 * Affiliate link helpers
 *
 * Set the relevant env vars in .env.local / Cloudflare Pages to activate:
 *   REACT_APP_GOG_AFFILIATE_ID   — GOG Partner ID (af.gog.com redirect program)
 *   REACT_APP_HUMBLE_PARTNER_ID  — Humble Bundle partner tag
 *   REACT_APP_FANATICAL_REF      — Fanatical ref tag (for future use)
 *
 * Epic / Steam / Itch.io do not offer traditional URL-based affiliate programs
 * for free game claims, so those URLs are returned unchanged.
 */

const GOG_AFFILIATE_ID    = process.env.REACT_APP_GOG_AFFILIATE_ID;
const HUMBLE_PARTNER_ID   = process.env.REACT_APP_HUMBLE_PARTNER_ID;
const FANATICAL_REF       = process.env.REACT_APP_FANATICAL_REF;

/**
 * Returns the affiliate-tagged version of a claim URL.
 * Falls back to the original URL if no affiliate ID is configured for that platform.
 *
 * @param {string} url       - Original claim URL from the game object
 * @param {string} platform  - Platform key: 'epic' | 'steam' | 'gog' | 'itchio' | 'humble' | 'fanatical'
 * @returns {string}
 */
export function affiliateUrl(url, platform) {
  if (!url) return url;

  try {
    switch (platform) {
      case 'gog': {
        if (!GOG_AFFILIATE_ID) return url;
        // GOG affiliate program uses af.gog.com as the redirect domain
        // https://www.gog.com/game/slug  →  https://af.gog.com/game/slug?as=PARTNER_ID
        const parsed = new URL(url);
        parsed.hostname = 'af.gog.com';
        parsed.searchParams.set('as', GOG_AFFILIATE_ID);
        return parsed.toString();
      }

      case 'humble': {
        if (!HUMBLE_PARTNER_ID) return url;
        const parsed = new URL(url);
        parsed.searchParams.set('partner', HUMBLE_PARTNER_ID);
        return parsed.toString();
      }

      case 'fanatical': {
        if (!FANATICAL_REF) return url;
        const parsed = new URL(url);
        parsed.searchParams.set('ref', FANATICAL_REF);
        return parsed.toString();
      }

      // Epic, Steam, Itch.io — no URL-based affiliate program for free games
      default:
        return url;
    }
  } catch {
    return url;
  }
}
